<template>
  <div
    class="layoutFooter"
  >
  Copyrights © 2019 - 2023 All Rights Reserved. 版权所有 甘肃省融资担保集团股份有限公司 陇ICP备17005709号 设计制作 宏点网络 <img src="https://www.gsrzdb.cn/hdimg/bas/images/ga.png" alt=""> 甘公网安备 62010202002786号 甘公网安备 62010202002786号
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.layoutFooter{
    padding:20px 0;
    background-color: #10284c;
    // vertical-align: middle;
    text-align: center;
    font-size: 14px;
    color: #F9FBFC;
  }
</style>
